import React, {Component} from 'react';
import styles from '../DennetMenu.module.css'
import PropTypes from 'prop-types';
import {createMedia} from '@artsy/fresnel'
import {Segment, Menu, Icon, Button} from 'semantic-ui-react';
import {NavLink} from 'react-router-dom';
import ContactModal from '../../../components/Contact';

const {Media} = createMedia({
    breakpoints: {
        mobile: 0,
        tablet: 768,
        computer: 1024,
    },
})

class DesktopContainer extends Component {
    state = {}

    render() {
        const {children, location} = this.props;

        const isActive = (path) => location.pathname === path;

        return (
            <Media greaterThan='mobile'>
                <Segment vertical style={{
                    height: isActive('/') ? '100vh' : 'inherit',
                    minHeight: isActive('/') ? '800px' : 'inherit',
                    backgroundColor: 'var(--background)',
                    position: 'relative'
                }}>
                    <NavLink to={'/'} style={{
                        position: 'fixed',
                        top: '20px',
                        left: '20px',
                        zIndex: 1000 // Ensure button stays on top of other content
                    }}>
                        <Button inverted color={'color1'} style={{}}>
                            <Icon
                                name='quote left'
                                size='large'
                                style={{opacity: 1}}
                            />
                        </Button>
                    </NavLink>



                    <Segment vertical basic style={{padding: '0'}}>
                        <Menu
                            borderless
                            secondary
                            size='massive'
                            style={{
                                borderBottom: '0px',
                            }}
                        >
                        </Menu>
                    </Segment>

                    {children}
                    {(isActive('/') && (

                        <Segment className={styles['manouk']} style={{
                            display: 'flex',
                            alignItems: 'flex-start',
                            flexDirection: 'column',
                            justifyContent: 'center'
                        }}>
                            <ContactModal className={styles['contact-modal']} color='white' fontsize='2.5em'
                                          weight='550'/>
                        </Segment>
                    ))}
                </Segment>
            </Media>
        );
    }
}

DesktopContainer.propTypes = {
    children: PropTypes.node,
    location: PropTypes.object.isRequired, // Ensure location is marked as required
}

export default DesktopContainer
